import { useState } from "react";
import styles from "./index.module.scss";
import Modal from "../../../components/UI/Modal/Modal";
import Input from "../../../components/UI/Input/Input";
import Button from "../../../components/UI/Button/Button";
import { AddAdmin, GetAllAdmins } from "../../../ApiCalls";

export default function AdminAddForm({ isOpen, onClose, setAdmin }) {
  const [formData, setFormData] = useState({
    phone: "",
  });
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.phone) newErrors.phone = "Required!";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddAdmin = async () => {
    if (!validateForm()) return;

    try {
      const response = await AddAdmin({ phone: formData.phone });

      if (response?.data?.success) {
        const adminsResponse = await GetAllAdmins();
        if (adminsResponse?.data?.success) {
          setAdmin(adminsResponse.data.admins);
        }
        onClose();
      }
    } catch (error) {
      console.log("Failed to add admin:", error);
    }
  };

  return (
    <Modal value={isOpen} title="Add Admin" parentClose={onClose}>
      <div className={styles.modalContent}>
        <div className={styles.inputWrapper}>
          <Input
            inputProperties={{
              config: {
                type: "text",
                value: formData.phone,
                placeholder: "Phone",
                maxLength: 10,
                onChange: (event) => {
                  setFormData((prev) => ({
                    ...prev,
                    phone: event.target.value,
                  }));
                  setErrors((prev) => ({
                    ...prev,
                    phone: undefined,
                  }));
                },
              },
              label: "Phone",
              error: errors.phone,
            }}
          />
        </div>
        <div className={styles.row}>
          <div className={styles.smallSubmit}>
            <Button styleType="light" onClick={onClose}>
              Cancel
            </Button>
          </div>
          <div className={styles.smallSubmit}>
            <Button onClick={handleAddAdmin}>Add</Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
